var INPUT_EVENT = 'update:modelValue';
var CLICK_EVENT = 'click';
var DISABLED_CLICK_EVENT = 'disabled-click';
var CHANGE_EVENT = 'change';
var DOM_CHANGE_EVENT = 'dom-change';
var FOLLOW_CHANGE_EVENT = 'follow-change';
var NEXT_FOLLOW_CHANGE_EVENT = 'next-follow-change';
var OPEN_EVENT = 'open';
var SHOW_EVENT = 'show';
var HIDE_EVENT = 'hide';
var CONFIRM_EVENT = 'confirm';
var CANCEL_EVENT = 'cancel';
var MAX_CHECKED_EVENT = 'max-checked';
var TOGGLE_EVENT = 'toggle';
var SELECT_EVENT = 'select';
var DELETE_EVENT = 'delete';
var CLOSE_EVENT = 'close';
var INCREASE_EVENT = 'increase';
var DECREASE_EVENT = 'decrease';
var FOCUS_EVENT = 'focus';
var BLUR_EVENT = 'blur';
var SCROLL_EVENT = 'scroll';
var TAB_SELECT_EVENT = 'tab-select';
var MASK_CLICK_EVENT = 'mask-click';
var BEFORE_SHOW_EVENT = 'before-show';
var BEFORE_HIDE_EVENT = 'before-hide';
var RIGHT_CLICK_EVENT = 'right-click';
var ERROR_EVENT = 'error';
var LOAD_EVENT = 'load';
var CLEAR_EVENT = 'clear';
var SCROLL_STATE_CHANGED_EVENT = 'scroll-state-change';
/**
 * context key
 */
var TABS_CONTEXT_KEY = 'tabs-context-key';
// 组件名前缀
var COMPONENT_PREFIX = 'sp';
// 组件样式前缀
var BLOCK_PREFIX = 'spu';

export { BEFORE_HIDE_EVENT, BEFORE_SHOW_EVENT, BLOCK_PREFIX, BLUR_EVENT, CANCEL_EVENT, CHANGE_EVENT, CLEAR_EVENT, CLICK_EVENT, CLOSE_EVENT, COMPONENT_PREFIX, CONFIRM_EVENT, DECREASE_EVENT, DELETE_EVENT, DISABLED_CLICK_EVENT, DOM_CHANGE_EVENT, ERROR_EVENT, FOCUS_EVENT, FOLLOW_CHANGE_EVENT, HIDE_EVENT, INCREASE_EVENT, INPUT_EVENT, LOAD_EVENT, MASK_CLICK_EVENT, MAX_CHECKED_EVENT, NEXT_FOLLOW_CHANGE_EVENT, OPEN_EVENT, RIGHT_CLICK_EVENT, SCROLL_EVENT, SCROLL_STATE_CHANGED_EVENT, SELECT_EVENT, SHOW_EVENT, TABS_CONTEXT_KEY, TAB_SELECT_EVENT, TOGGLE_EVENT };
